/**
 * 路由变化监听
 * 负责轮询管理和页面跳转逻辑
 */

import { isInvitationPage, isLoginPage } from './auth';
import { handleRouteChangeForPolling } from './polling';

const isDev = process.env.NODE_ENV === 'development';

/**
 * 路由变化处理函数
 * 根据当前路由状态管理轮询的启停
 */
export function onRouteChange({ location }: any): void {
  const currentIsLoginPage = isLoginPage(location?.pathname);
  const currentUserInvitationPage = isInvitationPage(location?.pathname);

  console.log(
    '[路由监听]',
    location?.pathname,
    '| 登录:',
    currentIsLoginPage,
    '| 邀请:',
    currentUserInvitationPage,
    '| 开发环境:',
    isDev,
  );

  // 判断是否应该启动轮询
  // 规则：非登录页面 && 非邀请页面 && 非开发环境
  const shouldPoll =
    !currentIsLoginPage && !currentUserInvitationPage && !isDev;

  // 管理轮询状态
  handleRouteChangeForPolling(shouldPoll);
}
